export default __webpack_public_path__ + "static/media/sean_face.a98738ae.png";